module.exports = __webpack_public_path__ + "img/communication15.84d98b6c.png";